import { type CheckoutOrder } from '@hooks-api/types/dataModel/orders'
import { Box } from '@pets-ui/Box/Box'
import { Text } from '@pets-ui/Text/Text'
import { colors } from '@pets-ui/tokens/colors.stylex'
import { useEffect, useMemo, useRef } from 'react'
import { useFormContext } from 'react-hook-form'

export const ShippingMethodErrorMessage = () => {
  const { formState: { errors } } = useFormContext<CheckoutOrder>()
  const errorRef = useRef<HTMLDivElement>(null)

  const errorMessages = useMemo(() => {
    const errorMessages: string[] = []
    if (errors.shippingMethodValidation?.message) {
      errorMessages.push(errors.shippingMethodValidation.message)
    }
    return errorMessages
  }, [errors.shippingMethodValidation])

  useEffect(() => {
    if (errorMessages.length > 0) {
      errorRef.current?.scrollIntoView({ behavior: 'smooth', block: 'center' })
    }
  }, [errorMessages])

  return (
    <Box display={errorMessages.length > 0 ? 'block' : 'none'} rootRef={errorRef}>
      {errorMessages.map(errorMessage => (
        <Box key={errorMessage} mt={2}>
          <Text variant="body" color={colors.red600}>{errorMessage}</Text>
        </Box>
      ))}
    </Box>
  )
}
